import styled from 'styled-components'

export const ActionButtons = styled.div`
  display: flex;
  column-gap: 8px;
`
